var _defs, _path, _path2, _rect, _path3, _path4, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.73 141.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M110.25 37.01L91.28 19.66H33.97c-2.01 0-3.66 1.65-3.66 3.66v94.67c0 2.01 1.65 3.66 3.66 3.66h72.62c2.01 0 3.66-1.65 3.66-3.66v-2.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M91.28 19.66v17.31l18.97.04v10.66"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "DI_4L_main",
    x: 61.21,
    y: 55.65,
    width: 51.65,
    height: 51.65,
    rx: 4.39,
    ry: 4.39
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "B_4L_main",
    d: "M54.8 72.12l-3-.02c-.69 0-1.25-.57-1.24-1.26 0-.69.56-1.24 1.25-1.24l3 .02c.69 0 1.25.57 1.24 1.26 0 .69-.56 1.24-1.25 1.24zM46.2 72.05l-3-.02c-.69 0-1.24-.56-1.24-1.25v-3a1.25 1.25 0 012.5 0v1.76h1.76c.69.02 1.25.58 1.24 1.27 0 .69-.56 1.24-1.25 1.24zM43.2 63.59c-.69 0-1.25-.56-1.25-1.25V56.9a1.25 1.25 0 012.5 0v5.44c0 .69-.56 1.25-1.25 1.25zm0-10.89c-.69 0-1.25-.56-1.25-1.25v-5.44a1.25 1.25 0 012.5 0v5.44c0 .69-.56 1.25-1.25 1.25zM43.2 41.82c-.69 0-1.25-.56-1.25-1.25v-3c0-.69.56-1.25 1.25-1.25h3a1.25 1.25 0 010 2.5h-1.75v1.75c0 .69-.56 1.25-1.25 1.25zM67.97 38.82h-5.44a1.25 1.25 0 010-2.5h5.44a1.25 1.25 0 010 2.5zm-10.89 0h-5.44a1.25 1.25 0 010-2.5h5.44a1.25 1.25 0 010 2.5zM76.39 41.82c-.69 0-1.25-.57-1.24-1.26v-1.74h-1.73a1.25 1.25 0 010-2.5h3c.33 0 .65.13.89.37s.37.56.36.89l-.02 3c0 .69-.56 1.24-1.25 1.24zM76.35 50.08c-.69 0-1.25-.57-1.24-1.26l.02-3c0-.69.56-1.24 1.25-1.24s1.25.57 1.24 1.26l-.02 3c0 .69-.56 1.24-1.25 1.24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "B_4L_main",
    d: "M54.8 72.12l-3-.02c-.69 0-1.25-.57-1.24-1.26 0-.69.56-1.24 1.25-1.24l3 .02c.69 0 1.25.57 1.24 1.26 0 .69-.56 1.24-1.25 1.24zM46.2 72.05l-3-.02c-.69 0-1.24-.56-1.24-1.25v-3a1.25 1.25 0 012.5 0v1.76h1.76c.69.02 1.25.58 1.24 1.27 0 .69-.56 1.24-1.25 1.24zM43.2 63.59c-.69 0-1.25-.56-1.25-1.25V56.9a1.25 1.25 0 012.5 0v5.44c0 .69-.56 1.25-1.25 1.25zm0-10.89c-.69 0-1.25-.56-1.25-1.25v-5.44a1.25 1.25 0 012.5 0v5.44c0 .69-.56 1.25-1.25 1.25zM43.2 41.82c-.69 0-1.25-.56-1.25-1.25v-3c0-.69.56-1.25 1.25-1.25h3a1.25 1.25 0 010 2.5h-1.75v1.75c0 .69-.56 1.25-1.25 1.25zM67.97 38.82h-5.44a1.25 1.25 0 010-2.5h5.44a1.25 1.25 0 010 2.5zm-10.89 0h-5.44a1.25 1.25 0 010-2.5h5.44a1.25 1.25 0 010 2.5zM76.39 41.82c-.69 0-1.25-.57-1.24-1.26v-1.74h-1.73a1.25 1.25 0 010-2.5h3c.33 0 .65.13.89.37s.37.56.36.89l-.02 3c0 .69-.56 1.24-1.25 1.24zM76.35 50.08c-.69 0-1.25-.57-1.24-1.26l.02-3c0-.69.56-1.24 1.25-1.24s1.25.57 1.24 1.26l-.02 3c0 .69-.56 1.24-1.25 1.24z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "c",
    className: "DI_4L_main",
    cx: 87.03,
    cy: 76.51,
    r: 6.79
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "d",
    className: "DI_4L_main",
    d: "M100.85 95.86c0-4.72-3.26-8.54-7.27-8.54H80.49c-4.02 0-7.27 3.83-7.27 8.54h27.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateBusiness);
export default __webpack_public_path__ + "static/media/template_business.5a837607de5251efdc06593305616214.svg";
export { ForwardRef as ReactComponent };